<app-badge-upper [text]="notifications" *ngIf="notifications; else empty">
  <app-icon>
    {{ icon }}
  </app-icon>
</app-badge-upper>
<ng-template #empty>
  <app-icon>{{ icon }}</app-icon>
</ng-template>
{{ title }}
